import { render, staticRenderFns } from "./GuideWidgetWrapper.vue?vue&type=template&id=32856638&scoped=true&"
import script from "./GuideWidgetWrapper.vue?vue&type=script&lang=js&"
export * from "./GuideWidgetWrapper.vue?vue&type=script&lang=js&"
import style0 from "./GuideWidgetWrapper.vue?vue&type=style&index=0&id=32856638&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32856638",
  null
  
)

export default component.exports